import { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { adminGetUserNameApi } from '../../../api/admin/user';
import { swalErrorAlert } from '../../../utils/swal/swal';

/* Components */
import SchoolRecordVer2ReadForm from '../../../components/schoolRecord/form/SchoolRecordVer2ReadForm';
import SavePDFButton from '../../../components/common/pdf/SavePDFButton';
import SchoolRecordReply from '../../../components/schoolRecord/reply/SchoolRecordReply';

const AdminSchoolRecordVer2ReadPage = () => {
    const { userId, schoolRecordId } = useParams()
    const [userName, setUserName] = useState('')

    const pdfRef = useRef();

    useEffect(() => {
        const getUserName = async (userId) => {
            if (!userId) {
                setUserName('')
                return
            }

            try {
                const response = await adminGetUserNameApi(userId)

                if (response.data?.code === 200) {
                    const userName = response.data?.resData?.user_name
                    setUserName(userName)
                } else {
                    setUserName('')
                }
                return

            } catch (error) {
                setUserName('')
                swalErrorAlert()
                return
            }
        }

        getUserName(userId)
    }, [])


    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">생활기록부 조회</h1>
            </div>

            {/* Content Row */}
            <div className="card shadow mb-4">

                <div className="card-header py-3">
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className="m-0 font-weight-bold">{userName} 학생 생활기록부</h6>
                        <SavePDFButton pdfRef={pdfRef} fileName={`${userName} 학생 생활기록부`} />
                    </div>
                </div>

                <div className="card-body">
                    <div className="">
                        <SchoolRecordVer2ReadForm schoolRecordId={schoolRecordId} pdfRef={pdfRef} isAdmin={true} />
                    </div>
                </div>

                <div className='card-footer'>
                    <div className='text-end'>
                        <Link to={`/hy-admin/school-record/list/${userId}`} className='btn btn-secondary'>목록으로</Link>
                    </div>
                </div>
            </div>

            <div className='card shadow mb-4'>
                <div className='card-header py-3'><h6 className='m-0 font-weight-bold'>댓글</h6></div>
                <div className='card-body' style={{ height: "auto", overflowY: "auto" }}>
                    <SchoolRecordReply schoolRecordId={schoolRecordId} />
                </div>
            </div>
        </div>
    )
}

export default AdminSchoolRecordVer2ReadPage